var _excluded = ["id", "className", "label", "mask", "placeholderChar"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
import { useField } from 'formik';
import MaskedInput from 'react-text-mask';
import { Label, Small } from './Text';
var Field = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 12px 16px;\n  width: 100%;\n\n  border: var(--input-border, var(--input-border-color));\n  background-color: var(--input-background-color);\n  outline: none;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--input-font-color);\n  line-height: 1;\n"])));
var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-bottom: 15px;\n\n  &.error {\n    ", ", ", " {\n      color: var(--error-color);\n    }\n\n    ", " {\n      color: var(--error-color);\n      border-color: var(--error-color);\n      background-color: var(--error-background-color);\n    }\n\n    ", " {\n      font-style: italic;\n    }\n  }\n"])), Label, Small, Field, Small);
var Input = React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      mask = _ref.mask,
      _ref$placeholderChar = _ref.placeholderChar,
      placeholderChar = _ref$placeholderChar === void 0 ? "\u2000" : _ref$placeholderChar,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useField = useField(_extends({
    id: id
  }, props)),
      field = _useField[0],
      meta = _useField[1];

  var error = meta.touched && meta.error;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: cx(className, {
      error: !!error
    })
  }, label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: id
  }, label), mask && /*#__PURE__*/React.createElement(MaskedInput, _extends({
    mask: mask,
    placeholderChar: placeholderChar,
    "data-testid": "input-mask"
  }, props, field, {
    render: function render(ref, fieldProps) {
      return /*#__PURE__*/React.createElement(Field, _extends({
        ref: ref,
        id: id
      }, fieldProps));
    }
  })), !mask && /*#__PURE__*/React.createElement(Field, _extends({
    ref: ref,
    id: id
  }, props, field)), error && /*#__PURE__*/React.createElement(Small, null, error));
});
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  // MaskedInput props
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  placeholderChar: PropTypes.string
} : {};
export default Input;